import { render, staticRenderFns } from "./GenericCard.vue?vue&type=template&id=640ad28a&scoped=true"
import script from "./GenericCard.vue?vue&type=script&lang=ts"
export * from "./GenericCard.vue?vue&type=script&lang=ts"
import style0 from "./GenericCard.vue?vue&type=style&index=0&id=640ad28a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ad28a",
  null
  
)

export default component.exports